import Cookies from 'js-cookie';

import { COOKIE_NAME_PROFILE_CACHE } from '@src/constants/cookie-names';
import { ssrOrMiddlewareLogger } from '@src/lib/middleware/utils';
import { ProfileWithMetadata } from '@src/types/api/models';
import { hasProfileToken } from '@src/utils/auth-token';
import { getCookie, SSROrMiddleware } from '@src/utils/cookies';

const jsonConverter = {
  read: <T extends Record<string, unknown> | string>(value: string) => JSON.parse(atob(value)) as T,
  write: <T extends Record<string, unknown> | string>(value: T) =>
    typeof value === 'object' ? btoa(JSON.stringify(value)) : btoa(value),
};

/**
 * Client-side cookie cashing uses the library js-cookie.
 * TODO: When migrating to the app directory we can retrieve cookies on the client-side with next directly.
 */
export const cacheProfile = (profile: Partial<ProfileWithMetadata> | null) => {
  try {
    const cookies = Cookies.withConverter(jsonConverter);

    if (profile) {
      cookies.set(COOKIE_NAME_PROFILE_CACHE, profile);
    } else {
      cookies.remove(COOKIE_NAME_PROFILE_CACHE);
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

/**
 * The profile cache is retrieved server-side only, where next provides cookie implementations.
 */
export const getProfileCache = (req: SSROrMiddleware) => {
  if (!hasProfileToken(req)) {
    return undefined;
  }

  const cookie = getCookie(req, COOKIE_NAME_PROFILE_CACHE);
  if (!cookie) {
    return undefined;
  }

  try {
    return jsonConverter.read<ProfileWithMetadata>(cookie);
  } catch (e) {
    ssrOrMiddlewareLogger.error('Could not parse profile cache cookie', cookie);
    return undefined;
  }
};

export const removeProfileCache = () => {
  const cookies = Cookies.withConverter(jsonConverter);
  cookies.remove(COOKIE_NAME_PROFILE_CACHE);
};
